import {AfterViewInit, Directive, ElementRef, HostListener, Input, OnInit, Renderer2} from '@angular/core';

@Directive({
             selector: '[appEllipsisWithTooltip]'
           })
export class EllipsisWithTooltipDirective implements OnInit, AfterViewInit {

  @Input() removeWrap = true;
  domElement: any;

  constructor(private elementRef: ElementRef,
              private renderer: Renderer2) {
  }

  ngOnInit(): void {
    this.domElement = this.elementRef.nativeElement;
    const ellipsis = {
      'text-overflow': 'ellipsis',
      overflow: 'hidden',
      'white-space': this.removeWrap ? 'nowrap' : 'normal'
    };
    Object.keys(ellipsis).forEach(element => {
      this.renderer.setStyle(
        this.domElement, `${element}`, ellipsis[element]
      );
    });
  }

  ngAfterViewInit(): void {
    this.renderer.setProperty(this.domElement, 'scrollTop', 1);
    this.setToolTip();
  }

  @HostListener('window:resize', ['$event.target'])
  setToolTip(): void {
    (this.domElement.offsetWidth < this.domElement.scrollWidth) ?
    this.renderer.setAttribute(this.domElement, 'title', this.domElement.textContent) :
    this.renderer.removeAttribute(this.domElement, 'title');
  }
}
